import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    isVisible: PropTypes.bool,
    manual: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    isVisible: false,
    manual: false,
};

class TooltipContainer extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            isVisible,
            manual,
        } = this.props;
        return [
            'c-tooltip-container',
            manual ? 'c-tooltip-container--manual' : 'c-tooltip-container--hover',
            isVisible ? 'is-visible' : null,
            className,
        ];
    }

}

TooltipContainer.propTypes = propTypes;

TooltipContainer.defaultProps = defaultProps;

export default TooltipContainer;
